import React from 'react';
import { connect } from 'react-redux';
import actions from '../../state/actions/multi-currency';
import MultiCurrencyDropdownLabel from './multi-currency-dropdown-label';
import MultiCurrencyList from './multi-currency-list';

class MultiCurrencyDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (
            this.props.openId === this.props.id &&
            this.wrapperRef &&
            !this.wrapperRef.contains(event.target)
        ) {
            this.props.dispatch(actions.closeMultiCurrencyDesktop());
        }
    }

    render() {
        const {
            dispatch,
            currencies,
            selectedCurrency,
            openId,
            id
        } = this.props;
        const open = openId === id;
        const toggle = () => {
            const shouldBeOpen = !open;
            dispatch(
                shouldBeOpen
                    ? actions.openMultiCurrencyDesktop(id)
                    : actions.closeMultiCurrencyDesktop()
            );
        };

        const selectCurrency = currency => () => {
            dispatch(actions.setPreferredCurrency(currency.code));
        };

        const selectedShortName = selectedCurrency
            ? selectedCurrency.shortName
            : '';
        const selectedLongName = selectedCurrency
            ? selectedCurrency.longName
            : '';

        return (
            <div
                className="multi-currency-selector-dropdown-trigger"
                onClick={toggle}
                ref={this.setWrapperRef}>
                <MultiCurrencyDropdownLabel
                    shortName={selectedShortName}
                    longName={selectedLongName}
                    showDownArrow={!open}
                    showUpArrow={open}
                />
                <div
                    className={
                        'multi-currency-selector-dropdown ' +
                        (open ? 'd-block' : 'd-none')
                    }>
                    <MultiCurrencyList
                        currencies={currencies}
                        selectedCurrencyCode={
                            selectedCurrency ? selectedCurrency.code : null
                        }
                        onCurrencySelected={selectCurrency}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        pageName: state.initData.pageName,
        currencies: state.initData.currencies,
        selectedCurrency: state.multiCurrency.preferredCurrency,
        openId: state.multiCurrency.desktopOpenId,
        ...ownProps
    };
};

export default connect(mapStateToProps)(MultiCurrencyDropdown);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/multi-currency/multi-currency-dropdown.jsx